import jwtAxios from 'utils/JWT'
import { resultArray } from "utils/C";
const Url = "http://175.126.38.45:8080";
// const Url = "http://127.0.0.1:8080";
export const axiosRequest = async (txt,method, url, data) => {
    try {
      const response = await jwtAxios[method](url, data);
      return response.data;
    } catch (error) {
      // 에러 처리 로직 추가
      console.log(`Error : ${txt} 요청이 실패했습니다. `, error);
      throw error;
    }
  };
export default {
    Login : `${Url}/api/v1/login`,
    RefreshJWT : `${Url}/api/v1/refresh`,
    StatusCount : `${Url}/api/v1/status-count`,
    MonthlyEvt : `${Url}/api/v1/monthly-evt`,
    DeviceLoad : `${Url}/api/v1/device`,
    DeviceSave : `${Url}/api/v1/device-add`,
    DeviceModify : `${Url}/api/v1/device-mod`,
    DeviceDelete : `${Url}/api/v1/device-del`,
    DevicesList : `${Url}/api/v1/devices`,
    DevicesMng: `${Url}/api/v1/devmng`,
    DeviceSearchM : `${Url}/api/v1/device-search-management`,
    DeviceSearchS : `${Url}/api/v1/device-search-status`,
    AlarmHistory: `${Url}/api/v1/alarmhistory`,
    alarmhistoryTotalNum: `${Url}/api/v1/alarm-histories-total`,
    UserLoad: `${Url}/api/v1/user`,
    UserIdDup: `${Url}/api/v1/user-id-dup`,
    UserSave: `${Url}/api/v1/user-add`,
    UserModify: `${Url}/api/v1/user-mod`,
    UserModMyPage: `${Url}/api/v1/user-modmy`,
    Identify : `${Url}/api/v1/identify`,
    UserDelete: `${Url}/api/v1/user-del`,
    UsersList: `${Url}/api/v1/users`,
    UserMng :`${Url}/api/v1/usermng`,
    UserSearch :`${Url}/api/v1/user-search`,
    UserPwChg :`${Url}/api/v1/user-pwchg`,
    DeptsList: `${Url}/api/v1/depts`,
    DeptDelete: `${Url}/api/v1/dept-del`,
    DeptAdd: `${Url}/api/v1/dept-add`,
    DeptModify: `${Url}/api/v1/dept-mod`,
    AlertHistories: `${Url}/api/v1/alert-histories`,
    AlertHistoriesTotal: `${Url}/api/v1/alert-histories-total`,

}
